import { render, staticRenderFns } from "./SingleTicket.vue?vue&type=template&id=75965f4c&"
import script from "./SingleTicket.vue?vue&type=script&lang=js&"
export * from "./SingleTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports